import React from 'react';
import InspectionCategory from './InspectionCategory';
import SectionHeaderWithIcon, { SectionHeaderTypes } from '../../Common/SectionHeaderWithIcon';

export default function InspectionContainer({ siteDocsData, onSelectDoc, viewDoc, downloadDoc, downloadAll, sectionName, sectionIcon }) {
    let docCategories = !siteDocsData.loading && siteDocsData.siteDocs && siteDocsData.siteDocs
        //.filter(projectDocType => projectDocType.id !== 1)/* Filter out Active Site Maps */
        .map(category => <InspectionCategory
            key={category.key}
            category={category}
            onSelectDoc={onSelectDoc}
            viewDoc={viewDoc}
            downloadDoc={downloadDoc}
            downloadAll={downloadAll} />); 

    return (<>
        <SectionHeaderWithIcon sectionName={sectionName} sectionIcon={sectionIcon} sectionHeaderType={SectionHeaderTypes.Primary} classes="" />
        <div className="inspectionsContainer">
            {docCategories}
        </div>
    </>);
}